
	import {
		Component,
		Model,
		Prop,
		Vue,
		Watch
	} from "vue-property-decorator";
	import Dialog from '@/components/dialog.vue';
	import RadioButton from '@/components/radio-button.vue';
	import PerformanceBlock from './performance-block.vue';
	import {
		getAgentUserInfo,
		getAgentRewardRecordList,
		getAgentUpperLogs,
		getAgentInviteLogs,
		getAgentLevelLogs,
		getAgentEarningsStatistics
	} from '@/api/agent_user';
	import {
		getTeamList
	} from '@/api/supplier'
	import {
		memberOrderList
	} from '@/api/order'
	import {
		getSearchDate,
		nextDay
	}from "@/utils/index"
	import {
		grade
	} from '@/utils/config';

	@Component({
		name: 'user-detail-dialog',
		components: {
			RadioButton,
			'slz-dialog': Dialog,
			PerformanceBlock
		}
	})
	export default class UserDetailDialog extends Vue {
		@Model('change') isShow!: boolean;
		@Prop({}) private id!: number;
		@Prop({}) private level:number
		private list: any = [];
		private showDialog = false;
		private filterTime: any = ''
		private userInfo: any = {}
		private gradeList: any = grade;
		private descRadioType = 0;
		private descRadioList: any = [{
				label: '会员详情',
				value: 0
			}, {
				label: '用户订单',
				value: 1
			},
			//  {
			// 	label: '奖励记录',
			// 	value: 2
			// }, 
			{
				label: '上级变更',
				value: 3
			}, {
				label: '推荐人变更',
				value: 4
			}, {
				label: '等级变更',
				value: 5
			}, {
				label: '团队',
				value: 6
			}, {
				label: '业绩',
				value: 7
			}
		];
		private pageNo = 1;
		private pageSize = 10;
		private total = 0;
		private earningInfo: any = {}
		private orderState = {
			'check_pending': {
				name: '待审核',
				color: 'blue'
			},
			'cancel': {
				name: '已取消',
				color: 'gary'
			},
			'complete': {
				name: '已完成',
				color: 'green'
			},
			'refund': {
				name: '已售后',
				color: 'red'
			},
			'processing': {
				name: '待发货',
				color: 'yellow'
			},
			'transport': {
				name: '已发货',
				color: 'yellow'
			},
			'timeout_cancel': {
				name: '超时取消',
				color: 'gary'
			}
		}

		@Watch('isShow')
		private onChangeShow(val: boolean) {
			this.showDialog = val;
			if (val) {
				this.descRadioType = 0;
				this.getInfo();
			}
		}

		private handleClose() {
			this.$emit('change', false);
		}

		private changePage(num: number, type: number) {
			// console.log(num,type)
			// console.log(this.pageNo,this.pageSize)
			this.handleChange(type, num,true);
		}

		private handleChange(e: any, page ? : number,pagechange?:boolean) {
			this.list = []
			this.total = 0
			if(!pagechange){
				this.pageSize = 10
				this.pageNo = 1
			}
			switch (e) {
				case 0:
					this.getInfo();
					break;
				case 1:
					this.pageNo = page || 1;
					this.getOrderList();
					break;
				case 2:
					this.pageNo = page || 1;
					this.getPrizeList();
					break;
				case 3:
					this.pageNo = page || 1;
					this.upperLog();
					break;
				case 4:
					this.pageNo = page || 1;
					this.inviteLog();
					break;
				case 5:
					this.pageNo = page || 1;
					this.levelLog();
					break;
				case 6:
					this.pageNo = page || 1;
					this.getTeam();
					break;
				case 7:
					this.filterTime = getSearchDate(1)
					this.getEarnings();
					break;
			}
		}

		/**
		 * 获取用户详细信息
		 */
		private async getInfo() {
			try {
				const res: any = await getAgentUserInfo({
					MemberId: this.id
				})
				this.userInfo = res.Result
			} catch (e) {
				console.log(e)
			}
		}

		/**
		 * 获取用户订单
		 */
		private async getOrderList() {
			let params: any = {
				Skip: (this.pageNo-1)*this.pageSize,
				Take: this.pageSize,
				MemberId:this.id,
			}
			try {
				const res: any = await memberOrderList(params);
				this.list = res.Result.Results || [];
				this.total = res.Result.Total;
			} catch (e) {
				console.log(e)
			}
		}

		/**
		 * 获取获利记录
		 */
		private async getPrizeList() {
			let params: any = {
				Skip: (this.pageNo-1)*this.pageSize,
				Take: this.pageSize,
				MemberId: this.id
			}
			try {
				const res: any = await getAgentRewardRecordList(params);
				this.list = res.Result.Results || []
				this.total = res.Result.Total;
			} catch (e) {
				console.log(e)
			}
		}

		/**
		 * 上级变更日志
		 */
		private async upperLog() {
			let params: any = {
				Skip: (this.pageNo-1)*this.pageSize,
				Take: this.pageSize,
				MemberId: this.id
			}
			try {
				const res: any = await getAgentUpperLogs(params);
				this.list = res.Result.Results || []
				this.total = res.Result.Total;
			} catch (e) {
				console.log(e)
			}
		}

		/**
		 * 邀请人变更日志
		 */
		private async inviteLog() {
			let params: any = {
				Skip: (this.pageNo-1)*this.pageSize,
				Take: this.pageSize,
				MemberId: this.id
			}
			try {
				const res: any = await getAgentInviteLogs(params);
				this.list = res.Result.Results || []
				this.total = res.Result.Total;
			} catch (e) {
				console.log(e)
			}
		}

		/**
		 * 等级变更日志
		 */
		private async levelLog() {
			let params: any = {
				Skip: (this.pageNo-1)*this.pageSize,
				Take: this.pageSize,
				MemberId: this.id
			}
			try {
				const res: any = await getAgentLevelLogs(params);
				this.list = res.Result.Results || []
				this.total = res.Result.Total;
				
			} catch (e) {
				console.log(e)
			}
		}


		private strTime(time,isend){
			if(time){
				let nt = new Date(time)
				let year = nt.getFullYear()
				let month = nt.getMonth()+1>10?nt.getMonth()+1:'0'+(nt.getMonth()+1)
				let day = nt.getDate()>10?nt.getDate():'0'+nt.getDate()
				if(isend){
					return nextDay([year,month,day].join('-'),1)
				}
				return [year,month,day].join('-')
			}
			return ''
		}
		/**
		 * 业绩
		 */
		private async getEarnings() {
			// console.log(this.filterTime)
			let params: any = {
				// Skip: (this.pageNo-1)*this.pageSize,
				// Take: this.pageSize,
				StartTime:this.strTime(this.filterTime[0],false),
				EndTime:this.strTime(this.filterTime[1],true),
				MemberId: this.id
			}
			try {
				const res: any = await getAgentEarningsStatistics(params);
				this.earningInfo = res.Result || {}
				// console.log(this.earningInfo)
			} catch (e) {
				console.log(e)
			}
		}

		/**
		 * 团队
		 */
		private async getTeam() {
			let params: any = {
				Skip: (this.pageNo-1)*this.pageSize,
				Take: this.pageSize,
				MemberId: this.id
			}
			try {
				const res: any = await getTeamList(params);
				this.list = res.Result.Results || [];
				this.total = res.Result.Total;
			} catch (err) {
				console.log(err)
			}
		}
	}
